import {ReactComponent as IconHome} from '../../../sprite/icon-home.svg';
import {ReactComponent as IconFolder} from '../../../sprite/icon-folder.svg';
import {ReactComponent as IconBook} from '../../../sprite/icon-book-2.svg';
import {ReactComponent as IconBag} from '../../../sprite/icon-bag.svg';
import {ReactComponent as IconContacts} from '../../../sprite/icon-contacts.svg';
import {ReactElement} from 'react';
import {Link} from 'react-router-dom';
import {AppRoute} from '../../../const/common';

export default function MainMenu(): ReactElement {
  return (
    <>
      <nav className="main-header__menu">
        <ul className="main-header__menu-list container">
          <li className="main-header__menu-item">
            <Link
              to={AppRoute.Root}
              className="main-header__menu-link link link_view--primary link_view--hover-accent text_size--16 text_line-height--150"
            >
              <IconHome className="icon" width={20} height={20}/>
              <span className="main-header__menu-item-text">
                Главная
              </span>
            </Link>
          </li>

          <li className="main-header__menu-item main-header__menu-item--services">
            <Link
              to={AppRoute.Catalog}
              className="main-header__menu-link link link_view--primary link_view--hover-accent text_size--16 text_line-height--150"
            >
              <IconFolder className="icon" width={20} height={20}/>
              <span className="main-header__menu-item-text">
                Каталог
              </span>
            </Link>

            <ul className="main-header__services grid grid_col--3 grid_gap--s-m-m">
              <li className="main-header__services-item">
                <h3 className="text_size--16 text_line-height--150 text_weight--500 text_view--base space_bottom-s">
                  <a href="" className="link link_view--primary link_view--hover-accent">Игры</a>
                </h3>

                <ul className="main-header__services-sublist grid grid_gap--3xs">
                  <li className="main-header__services-subitem">
                    <a href="" className="link link_view--primary link_view--hover-accent text_size--14">ТЗ для браузерных игр</a>
                  </li>
                  <li className="main-header__services-subitem">
                    <a href="" className="link link_view--primary link_view--hover-accent text_size--14">ТЗ для компьютерных игр</a>
                  </li>
                  <li className="main-header__services-subitem">
                    <a href="" className="link link_view--primary link_view--hover-accent text_size--14">ТЗ для мобильных игр</a>
                  </li>
                </ul>
              </li>

              <li className="main-header__services-item">
                <h3 className="text_size--16 text_line-height--150 text_weight--500 text_view--base space_bottom-s">
                  <a href="" className="link link_view--primary link_view--hover-accent">Приложения</a>
                </h3>

                <ul className="main-header__services-sublist grid grid_gap--3xs">
                  <li className="main-header__services-subitem">
                    <a href="" className="link link_view--primary link_view--hover-accent text_size--14">ТЗ для Android</a>
                  </li>
                </ul>
              </li>

              <li className="main-header__services-item">
                <h3 className="text_size--16 text_line-height--150 text_weight--500 text_view--base space_bottom-s">
                  <a href="" className="link link_view--primary link_view--hover-accent">Сайты</a>
                </h3>

                <ul className="main-header__services-sublist grid grid_gap--3xs">
                  <li className="main-header__services-subitem">
                    <a href="" className="link link_view--primary link_view--hover-accent text_size--14">ТЗ для сайта-визитки</a>
                  </li>
                  <li className="main-header__services-subitem">
                    <a href="" className="link link_view--primary link_view--hover-accent text_size--14">ТЗ для портала</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li className="main-header__menu-item">
            <Link
              to={AppRoute.Blog}
              className="main-header__menu-link link link_view--primary link_view--hover-accent text_size--16 text_line-height--150"
            >
              <IconBook className="icon" width={20} height={20}/>
              <span className="main-header__menu-item-text">
                Блог
              </span>
            </Link>
          </li>

          <li className="main-header__menu-item">
            <Link
              to={AppRoute.Payment}
              className="main-header__menu-link link link_view--primary link_view--hover-accent text_size--16 text_line-height--150"
            >
              <IconBag className="icon" width={20} height={20}/>
              <span className="main-header__menu-item-text">
                Оплата и доставка
              </span>
            </Link>
          </li>

          <li className="main-header__menu-item">
            <Link
              to={AppRoute.Contacts}
              className="main-header__menu-link link link_view--primary link_view--hover-accent text_size--16 text_line-height--150"
            >
              <IconContacts className="icon" width={20} height={20}/>
              <span className="main-header__menu-item-text">
                Контакты
              </span>
            </Link>
          </li>
        </ul>
      </nav>
    </>
  )
}
